import { z } from 'zod';

import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const GeogebraQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.GeogebraQuestion).extend({
  appletAltText: z.string().default(''),
  questionFileUrl: z.string().default(''),
  showAlgebraInput: z.boolean().default(false),
  enableRightClick: z.boolean().default(false),
  showToolBar: z.boolean().default(false),
  allowStyleBar: z.boolean().default(false),
  showMenuBar: z.boolean().default(false),
  enableShiftDragZoom: z.boolean().default(false)
});

export type GeogebraQuestionWidgetStaticSchema = z.infer<typeof GeogebraQuestionWidgetStaticSchema>;
